import axios from 'axios';
import sha1 from 'sha1';
import qs from 'qs';
import { ElMessageBox } from "element-plus";
import store from '../store/index'
import router from "../router/index"
import { Base64 } from 'js-base64';
const BASEURL = process.env.NODE_ENV === "production" ? 'http://47.105.39.99:8899' : 'http://192.168.0.109:8088';
const service = axios.create({
  timeout: 5000,
  baseURL: "http://47.105.39.99:8899",
})
// http request 拦截器
service.interceptors.request.use(config => {
  // 0. 过滤获取token的请求
  if (config.url === '/api/login/get_verification') {
    return config
  }
  // 获取 token 和 sk
  let token = localStorage.getItem('qlzx_monitoring_api_token') || '';
  let sk = localStorage.getItem('qlzx_monitoring_api_sk') || '';
  // 1. 获取请求参数 row
  // let data = config.data;

  //  let row = data.row 
  let data = config?.data || (config['data'] = []);
  let row = data?.row || (config['data']['row'] = []);


  // 2. 将 row 中植入 token 和 time_stamp 当前时间戳(秒)
  row['token'] = token;
  row['time_stamp'] = '' + Date.parse(new Date()) / 1000;
  // 3. 将row参数进行升序排序
  const newkey = Object.keys(row).sort();
  const newObj = {};
  for (let i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = row[newkey[i]];
  }
  // 4. 将键和值进行 URLcode 编码 ,= 不需要编码
  let sign_list = [];
  for (let item in newObj) {
    let _key = item;
    let _val = newObj[item];
    sign_list.push(Base64.encode(_key) + "=" + Base64.encode(_val));
  }
  // for (let item in newObj) {
  //   let _key = item;
  //   let _val = newObj[item];
  //   sign_list.push(encodeURIComponent(_key) + "=" + encodeURIComponent(_val));
  // }
  // 5. 将将键值对重新组
  let sign_str = sign_list.join('&');
  // 6. 使用秘钥将其前后拼接 生成待签名字符串
  sign_str = sign_str.replace(/\%20/g, '+');
  sign_str = sk + sign_str + sk;
  // 7. 使用 sha1 的加密算法将其签名
  sign_str = sha1(sign_str);

  // 8. 将签名的字符串放到与 row 同级参数上 sign 
  data['sign'] = sign_str;
  config.data = qs.stringify(data)
  return config
}, err => {
  return err
})
service.interceptors.response.use(response => {
  //用于判断 未登录只弹出一次弹窗
  let count = store.state.second
  //接收返回数据..
  const res = response.data
  // 判断状态code是否为指定数值
  if (response.data.code != 0) {
    if (response.data.code === -9998 || response.data.code === -9999) {
      if (count === 0) {
        store.commit('zeng')
        localStorage.clear();
        showMessageLOGIN(res);
      }
    } else {
      showMessage(res)
    }
  }
  return res
}, err => {
  return err;
})
//封装错误提示信息..
function showMessage(res) {
  ElMessageBox.alert(res.message, "系统提示", {
    confirmButtonText: "OK",
  })
}
function showMessageLOGIN(res) {
  router.push("/Login")
  ElMessageBox.alert(res.message, "系统提示", {
    confirmButtonText: "OK",
    callback: (action) => {
   
    },
  })
}
export default service;